<template>
  <b-form @submit.prevent="updateStatus()">
    <b-form-row v-if="statusOptions.length > 0">
      <div class="form-group col-sm-8">
        <label for="change-status" v-translate>Change Shipment Status</label>
        <div class="input-group">
          <b-form-select v-model="newShippingStatus" :options="statusOptions" class="mb-2 mr-sm-2 mb-sm-0" required id="change-status">
            <template #first>
              <b-form-select-option :value="null" v-translate>-- Select an option --</b-form-select-option>
            </template>
          </b-form-select>
        </div>
        <div v-if="newShippingStatus === 'READY' || newShippingStatus === 'WAITING'">
          <b-form-group class="mt-2">
            <label for="scheduled-at" class="d-block" v-translate>Schedule Date (optional)</label>
            <b-form-input type="date" v-model="reScheduledAt" class="form-control" style="width: auto; display: inline-block" />
            <b-form-select v-model="reScheduledAtHour" :options="timeSlots" style="width: auto; display: inline-block"></b-form-select>
          </b-form-group>
        </div>
        <div v-if="newShippingStatusNeedReason">
          <div class="invalid-feedback d-block mb-3" v-translate="{status: newShippingStatus}">
            %{status} status requires to select/write a reason below before submit the new status.
          </div>
          <b-form-group>
            <label for="status-reason" v-translate>Status Reason</label>
            <b-form-radio-group stacked id="status-reason" v-model="newShippingStatusReason" :options="newShippingStatusReasons" required>
              <template #first>
                <b-form-radio v-if="newShippingStatus === 'TOBERETURNED'" :value="{reason: 'max_retries_reached'}" class="w-100"><translate>Maximum retries reached</translate></b-form-radio>
              </template>
              <b-form-radio v-if="newShippingStatus === 'CANCELED'" :value="{reason: 'created_by_mistake'}"><translate>Created by mistake</translate></b-form-radio>
              <b-form-radio :value="{reason: 'other'}"><translate>Others</translate></b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group v-if="newShippingStatusReason.reason === 'other'">
            <label for="reason-description" v-translate>Reason Description</label>
            <div class="input-group">
              <b-form-textarea
                id="reason-description"
                v-model="newShippingStatusMeta"
                rows="3"
                max-rows="6"
                :state="validateIncidenceDesc"
                required
              />
              <b-form-invalid-feedback :state="validateIncidenceDesc" v-translate="{status: newShippingStatus}">
                "Others" %{status} status requires a description. Please be brief but descriptive.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validateIncidenceDesc" v-translate>
                Alright.
              </b-form-valid-feedback>
            </div>
          </b-form-group>
        </div>
        <div v-if="newShippingStatus === 'DELIVERED'">
          <br>
          <label for="receiver_type_id" v-translate>Receiver Type</label>
          <div class="input-group">
            <b-form-select v-model="deliveredStatusDetailFields.receiver_type_id" :options="receiverTypes.map(x => { return {text: receiverTypesStrings[x.name], value: x.id} })" class="mb-2 mr-sm-2 mb-sm-0" id="receiver_type_id">
              <template #first>
                <b-form-select-option :value="null" v-translate>-- Select an option --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
          <br>
          <label for="receiver_first_name" v-translate>Receiver First Name</label>
          <div class="input-group">
            <b-form-input v-model="deliveredStatusDetailFields.receiver_first_name" class="mb-2 mr-sm-2 mb-sm-0" id="receiver_first_name" required />
          </div>
          <br>
          <label for="receiver_last_name" v-translate>Receiver Last Name</label>
          <div class="input-group">
            <b-form-input v-model="deliveredStatusDetailFields.receiver_last_name" class="mb-2 mr-sm-2 mb-sm-0" id="receiver_last_name" required />
          </div>
          <br>
          <label for="receiver_address_street" v-translate>Address Street</label>
          <div class="input-group">
            <b-form-input v-model="deliveredStatusDetailFields.receiver_address_street" class="mb-2 mr-sm-2 mb-sm-0" id="receiver_address_street" required />
          </div>
          <br>
          <label for="receiver_address_number" v-translate>Address Number</label>
          <div class="input-group">
            <b-form-input v-model="deliveredStatusDetailFields.receiver_address_number" class="mb-2 mr-sm-2 mb-sm-0" id="receiver_address_number" required />
          </div>
          <br>
          <label for="receiver_address_extra" v-translate>Address Extra</label>
          <div class="input-group">
            <b-form-input v-model="deliveredStatusDetailFields.receiver_address_extra" class="mb-2 mr-sm-2 mb-sm-0" id="receiver_address_extra" />
          </div>
          <br>
          <label for="receiver_phone" v-translate>Receiver Phone</label>
          <div class="input-group">
            <b-form-input v-model="deliveredStatusDetailFields.receiver_phone" class="mb-2 mr-sm-2 mb-sm-0" id="receiver_phone" required />
          </div>
        </div>
      </div>
      <div class="form-group col-sm-4">
        <label for="from_extra">&nbsp;</label>
        <div class="input-group">
          <b-button type="submit" :disabled="disableSetStatus" v-translate>Submit</b-button>
        </div>
      </div>
    </b-form-row>
  </b-form>
</template>

<script>
import constants from '@/common/constants'

export default {
  name: 'ShippingStatusUpdate',
  props: {
    shipping: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      newShippingStatus: null,
      reScheduledAt: null,
      reScheduledAtHour: '00:00',
      timeSlots: Array(24 * 2 + 1).fill(0).map((_, i) => {
        return {
          text: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replace(/\d(\d\d)/g, '$1'),
          value: ('0' + ~~(i / 2) + ':0' + 60 * (i / 2 % 1)).replace(/\d(\d\d)/g, '$1')
        }
      }),
      newShippingStatusReason: {},
      newShippingStatusMeta: null,
      deliveredStatusDetailFields: {
        receiver_type_id: null
      }
    }
  },
  computed: {
    // CONFIRMED is never offered: assigning a courier goes through the carrier assign endpoint (MOOV-5477)
    statusOptions() {
      const statuses = this.shipping?.status
        ? this.statusesMap[this.shipping.status]
        : (this.ecosystemConfig.collectionStatuses || Object.keys(this.statusesMap))
      return (statuses || []).filter(status => status !== 'CONFIRMED')
    },
    validateIncidenceDesc() {
      return this.newShippingStatusMeta !== null && this.newShippingStatusMeta.length > 10
    },
    newShippingStatusNeedReason() {
      return this.statusNeedReason.indexOf(this.newShippingStatus) !== -1
    },
    newShippingStatusReasons() {
      if (this.newShippingStatus === 'CANCELED' || this.newShippingStatus === 'RETURNED') {
        return this.shippingStatusReasons[Object.entries(this.statusEvents).find(x => x[1].indexOf(this.newShippingStatus) !== -1)[0]].map(x => {
          return {
            text: this.statusReasonsStrings[x.name],
            value: { reason: x.name, reason_id: x.reason_id }
          }
        })
      } else {
        if (this.shipping?.status) {
          return this.shippingStatusReasons[Object.entries(this.statusEvents).find(x => x[1].indexOf(this.shipping.status) !== -1)[0]].map(x => {
            return {
              text: this.statusReasonsStrings[x.name],
              value: { reason: x.name, reason_id: x.reason_id }
            }
          })
        }
      }
    },
    disableSetStatus() {
      return this.newShippingStatusNeedReason && (!this.newShippingStatusReason.reason || (this.newShippingStatusReason.reason === 'other' && !this.validateIncidenceDesc))
    }
  },
  watch: {
    'deliveredStatusDetailFields.receiver_type_id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && newVal !== null) {
          if (this.receiverTypes.find(x => x.id === newVal).name === 'same_person_or_family') {
            this.deliveredStatusDetailFields.receiver_first_name = this.shipping.to_contact
            this.deliveredStatusDetailFields.receiver_address_street = this.shipping.address_to.formatted_address
            this.deliveredStatusDetailFields.receiver_address_extra = this.shipping.to_extra
            this.deliveredStatusDetailFields.receiver_phone = this.shipping.to_phone
            this.deliveredStatusDetailFields.receiver_signature = 'manual'
          } else {
            this.deliveredStatusDetailFields = {
              receiver_type_id: newVal
            }
          }
        }
      },
      deep: true
    }
  },
  mixins: [constants],
  mounted () {
    this.deliveredStatusDetailFields = {
      ...this.deliveredStatusDetailFields,
      ...{
        receiver_first_name: '-',
        receiver_last_name: '-',
        receiver_address_street: '-',
        receiver_address_number: '-',
        receiver_address_extra: '-',
        receiver_phone: '-',
        receiver_signature: 'manual'
      }
    }
  },
  methods: {
    async updateStatus() {
      const ids = this.shipping?.id || this.collection.map(x => x.id)
      let params
      if (!Array.isArray(ids)) {
        if (this.newShippingStatus === 'READY' && this.reScheduledAt) {
          this.reScheduledAt += ' ' + this.reScheduledAtHour + ':00'
          const utcDate = this.moment(this.reScheduledAt).utc().format('YYYY-MM-DD HH:mm:ss')

          params = {
            shipping_id: ids,
            user_id: this.profile.id,
            status: this.newShippingStatus,
            meta: 'RESCHEDULED AT ' + utcDate + ' UTC'
          }

          this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
            .then(response => {
              const shipping = {
                scheduled_date: utcDate,
                instructions: 'RESCHEDULED ' + this.shipping.instructions
              }
              this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id, shipping)
                .then(() => {
                  this.$emit('updated', true)
                  this.reScheduledAt = null
                  this.newShippingStatus = null
                  this.newShippingStatusMeta = null
                  this.newShippingStatusReason = {}
                })
            })
        } else {
          params = {
            shipping_id: ids,
            user_id: this.profile.id,
            status: this.newShippingStatus,
            meta: this.newShippingStatusMeta || null
          }
          if (this.newShippingStatusNeedReason) {
            params.details = this.newShippingStatusReason
          }
          if (this.newShippingStatus === 'DELIVERED') {
            params.details = this.deliveredStatusDetailFields
            if (!params.details.receiver_type_id) {
              params.details.receiver_type_id = this.receiverTypes.find(x => x.name === 'same_person_or_family').id
            }
          }
          if (params.details?.reason_id) {
            params.shipping_status_reasons_id = params.details.reason_id
          }
          this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
            .then(() => {
              setTimeout(function () {
                // TODO: emit shipping updated
                this.$emit('updated', true)
                this.newShippingStatus = null
                this.newShippingStatusMeta = null
                this.newShippingStatusReason = {}
              }.bind(this), 1000)
            })
        }
      } else {
        if (
          confirm(this.$gettext('Are you sure you want to CHANGE the current Collection statuses?'))
        ) {
          this.isLoading = true
          const chunkSize = 40
          const completeCollection = [...new Set(ids)]
          const chunks = [...Array(Math.ceil(ids.length / chunkSize))].map(_ => completeCollection.splice(0, chunkSize))
          for (let i = 0; i < chunks.length; i++) {
            await this.doUpdateStatus(chunks[i])
              .then(response => {
                if (i === (chunks.length - 1)) {
                  setTimeout(() => {
                    this.$root.$emit('bv::refresh::table', 'my-table')
                    this.$emit('updated', true)
                  }, 100)
                  this.reScheduledAt = null
                  this.newShippingStatus = null
                  this.newShippingStatusMeta = null
                  this.newShippingStatusReason = {}
                  this.isLoading = false
                }
              }, error => {
                const obj = {
                  title: 'ERROR',
                  message: error.body.message,
                  type: 'error'
                }
                this.$parent.$refs.simplert.openSimplert(obj)
                if (i === (chunks.length - 1)) {
                  setTimeout(() => {
                    this.$root.$emit('bv::refresh::table', 'my-table')
                    this.$emit('updated', true)
                  }, 100)
                  this.reScheduledAt = null
                  this.newShippingStatus = null
                  this.newShippingStatusMeta = null
                  this.newShippingStatusReason = {}
                  this.isLoading = false
                }
              })
          }
        }
      }
    },
    async doUpdateStatus(shippingCollection) {
      let params
      this.reScheduledAt = this.reScheduledAt ? this.reScheduledAt + ' 00:00:00' : null
      if (this.newShippingStatus === 'READY' && this.reScheduledAt) {
        const utcDate = this.moment(this.reScheduledAt).utc().format('YYYY-MM-DD HH:mm:ss')
        console.log(utcDate)
        params = {
          shippings: shippingCollection,
          user_id: this.profile.id,
          status: this.newShippingStatus,
          meta: 'RESCHEDULED AT ' + utcDate + ' UTC'
        }

        this.$http.post(this.$appConfig.api.baseUrl + 'shippings/statuses', params)
          .then(response => {
            const statuses = response.body
            for (let i = 0; i < statuses.length; i++) {
              const shipping = {
                scheduled_date: utcDate,
                instructions: 'RESCHEDULED ' + this.shippingViewObject.find(x => x.id === statuses[i].shipping_id).instructions
              }
              this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + shippingCollection[i], shipping)
            }
          })
      } else {
        params = {
          shippings: shippingCollection,
          user_id: this.profile.id,
          status: this.newShippingStatus,
          meta: this.newShippingStatusMeta || null
        }
        if (this.newShippingStatusNeedReason) {
          params.details = this.newShippingStatusReason
        }
        if (this.newShippingStatus === 'DELIVERED') {
          params.details = this.deliveredStatusDetailFields
          if (!params.details.receiver_type_id) {
            params.details.receiver_type_id = this.receiverTypes.find(x => x.name === 'same_person_or_family').id
          }
        }
        if (params.details?.reason_id) {
          params.shipping_status_reasons_id = params.details.reason_id
        }

        return this.$http.post(this.$appConfig.api.baseUrl + 'shippings/statuses', params)
      }
    }
  }
}
</script>
